import { useToast } from 'hephaestus/web';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const isAllocationFraction = (fraction: number) =>
  Number.isFinite(fraction) && fraction >= 0 && fraction <= 1;

export const useRejectOutOfRange = () => {
  const { enqueueToast } = useToast();
  const { t } = useTranslation(['components']);

  return useCallback(
    (fractions: number[]) => {
      if (fractions.every(isAllocationFraction)) return false;
      enqueueToast(t('components:householdPortfolio.percentageOutOfRange'), {
        variant: 'warning',
      });
      return true;
    },
    [enqueueToast, t],
  );
};
